import React from 'react';

const SIZE_CLASSES = {
  sm: {
    wrapper: 'h-8',
    ring: 'h-8 w-8',
    text: 'text-xs'
  },
  md: {
    wrapper: 'h-32',
    ring: 'h-12 w-12',
    text: 'text-sm'
  },
  lg: {
    wrapper: 'h-64',
    ring: 'h-16 w-16',
    text: 'text-base'
  }
};

const LoadingSpinner = ({ size = 'md', className = '', label = 'Loading...' }) => {
  const selectedSize = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div className={`flex items-center justify-center ${selectedSize.wrapper} ${className}`}>
      <div className="relative flex flex-col items-center">
        <div className={`relative ${selectedSize.ring}`}>
          <div className="absolute inset-0 rounded-full border-4 border-slate-200" />
          <div className="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-[#f97316] border-r-[#1d4ed8]" />
          <div className="absolute inset-2 flex items-center justify-center rounded-full bg-white shadow-sm">
            <span className={`font-black tracking-tight text-slate-900 ${selectedSize.text}`}>
              <span className="text-[#1d4ed8]">3PL</span>
              <span className="text-[#f97316]">+</span>
            </span>
          </div>
          <div className="pointer-events-none absolute inset-1 rounded-full bg-gradient-to-r from-transparent via-white/80 to-transparent animate-pulse opacity-80" />
        </div>
        {label && (
          <div className="mt-3 text-sm font-medium text-slate-500">
            {label}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
